var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chat_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 55.375,
    x: -10.594,
    y: -7.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#chat_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#chat_svg__c)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chat_svg__d)",
    d: "M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h20.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C40 4.56 40 6.24 40 9.6v8.514c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622c-1.283.654-2.964.654-6.324.654H12.997c-.37 0-.555 0-.734.033q-.239.044-.46.144c-.166.074-.319.18-.624.39l-6.16 4.254c-1.627 1.123-2.44 1.684-3.115 1.651a2 2 0 0 1-1.493-.783C0 32.865 0 31.878 0 29.902z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M9.6.5h20.8c1.688 0 2.925 0 3.9.08.97.08 1.638.235 2.197.52A5.5 5.5 0 0 1 38.9 3.503c.285.56.44 1.228.52 2.197.08.976.08 2.212.08 3.9v8.514c0 1.689 0 2.925-.08 3.9-.08.97-.235 1.637-.52 2.197a5.5 5.5 0 0 1-2.403 2.404c-.56.285-1.228.44-2.197.519-.975.08-2.211.08-3.9.08H12.997c-.352 0-.59-.002-.824.04a2.5 2.5 0 0 0-.576.18c-.217.098-.412.235-.701.435l-6.162 4.255c-.82.567-1.408.972-1.875 1.234-.47.266-.74.338-.931.329a1.5 1.5 0 0 1-1.12-.587c-.116-.153-.21-.415-.26-.953C.5 31.614.5 30.899.5 29.9V9.6c0-1.688 0-2.924.08-3.9.08-.97.235-1.638.52-2.197A5.5 5.5 0 0 1 3.503 1.1C4.063.815 4.73.66 5.7.58 6.676.5 7.912.5 9.6.5Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 55.375,
    x: 5.406,
    y: 12.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#chat_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#chat_svg__f)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chat_svg__g)",
    fillOpacity: 0.2,
    d: "M56 29.6c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C51.44 20 49.76 20 46.4 20H25.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C16 24.56 16 26.24 16 29.6v8.514c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622c1.284.654 2.964.654 6.324.654h17.403c.37 0 .555 0 .734.033q.239.044.46.144c.166.074.319.18.624.39l6.16 4.254c1.627 1.123 2.44 1.684 3.115 1.651a2 2 0 0 0 1.493-.783c.411-.538.411-1.526.411-3.501z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#chat_svg__h)",
    d: "M56 29.6c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C51.44 20 49.76 20 46.4 20H25.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C16 24.56 16 26.24 16 29.6v8.514c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622c1.284.654 2.964.654 6.324.654h17.403c.37 0 .555 0 .734.033q.239.044.46.144c.166.074.319.18.624.39l6.16 4.254c1.627 1.123 2.44 1.684 3.115 1.651a2 2 0 0 0 1.493-.783c.411-.538.411-1.526.411-3.501z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M46.4 20.5H25.6c-1.688 0-2.925 0-3.9.08-.97.08-1.638.235-2.197.52a5.5 5.5 0 0 0-2.403 2.403c-.286.56-.44 1.228-.52 2.197-.08.976-.08 2.212-.08 3.9v8.514c0 1.689 0 2.925.08 3.9.08.97.235 1.637.52 2.197a5.5 5.5 0 0 0 2.403 2.404c.56.285 1.228.44 2.197.519.976.08 2.212.08 3.9.08h17.403c.352 0 .59-.002.824.04q.3.056.576.18c.217.098.412.235.702.435l6.16 4.255c.822.567 1.41.972 1.876 1.234.47.266.74.338.931.329a1.5 1.5 0 0 0 1.12-.587c.116-.153.21-.415.26-.953.048-.533.048-1.248.048-2.246V29.6c0-1.688 0-2.925-.08-3.9-.08-.97-.235-1.638-.52-2.197a5.5 5.5 0 0 0-2.403-2.403c-.56-.286-1.228-.44-2.197-.52-.975-.08-2.212-.08-3.9-.08Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chat_svg__b",
    transform: "translate(10.594 7.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h20.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C40 4.56 40 6.24 40 9.6v8.514c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622c-1.283.654-2.964.654-6.324.654H12.997c-.37 0-.555 0-.734.033q-.239.044-.46.144c-.166.074-.319.18-.624.39l-6.16 4.254c-1.627 1.123-2.44 1.684-3.115 1.651a2 2 0 0 1-1.493-.783C0 32.865 0 31.878 0 29.902z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chat_svg__e",
    transform: "translate(-5.406 -12.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 29.6c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C51.44 20 49.76 20 46.4 20H25.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C16 24.56 16 26.24 16 29.6v8.514c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622c1.284.654 2.964.654 6.324.654h17.403c.37 0 .555 0 .734.033q.239.044.46.144c.166.074.319.18.624.39l6.16 4.254c1.627 1.123 2.44 1.684 3.115 1.651a2 2 0 0 0 1.493-.783c.411-.538.411-1.526.411-3.501z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chat_svg__d",
    x1: 21.25,
    x2: 21.25,
    y1: 0.529,
    y2: 60.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chat_svg__g",
    x1: 36,
    x2: 36,
    y1: 35.975,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "chat_svg__c",
    width: 61.188,
    height: 55.375,
    x: -10.594,
    y: -7.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_8927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_8927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "chat_svg__f",
    width: 61.188,
    height: 55.375,
    x: 5.406,
    y: 12.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_8927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_8927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "chat_svg__h",
    width: 1.6,
    height: 1.778,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chat_svg__i",
    transform: "scale(.00156 .00174)"
  })))));
};
export default SvgChat;